<template>
    <div>
        <!-- Export в ecxel -->
        <div class="flex justify-end mb-2">
            <vs-button
                color="success"
                id="button-load-more-posts"
                class="vs-con-loading__container ml-2"
                icon-pack="feather"
                icon="icon-download"
                @click="getExcelToken"
                >{{ $t("download_table") }}</vs-button
            >
        </div>
        <!-- Таблица с бесконечной прокруткой -->
        <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
        >
            <vs-table
                :noDataText="$t('no_data')"
                id="registration-results"
                :data="listResults"
            >
                <template slot="thead">
                    <vs-th>{{ $t("acad_periods") }}</vs-th>
                    <vs-th>{{ $t("discipline-title") }}</vs-th>
                    <vs-th>{{ $t("type-load") }}</vs-th>
                    <vs-th>{{ $t("count_hours") }}</vs-th>
                    <vs-th>{{ $t("lang-teacher-v2") }}</vs-th>
                    <vs-th>{{ $t("teacher") }}</vs-th>
                    <vs-th v-if="user && user.role.is_org_admin">{{ $t("is_supervisor") }}</vs-th>
                    <vs-th>{{ $t("count_reg_students") }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in listResults">
                        <vs-td :data="data[indextr].acad_period_repr_name">
                            {{ data[indextr].acad_period_repr_name }}
                        </vs-td>
                        <vs-td :data="data[indextr].discipline">
                            {{ data[indextr].discipline }}
                        </vs-td>

                        <vs-td :data="data[indextr].load_type">
                            {{ data[indextr].load_type }}
                        </vs-td>

                        <vs-td :data="data[indextr].hours">
                            {{ data[indextr].hours }}
                        </vs-td>

                        <vs-td :data="data[indextr].language">
                            {{ data[indextr].language }}
                        </vs-td>

                        <vs-td :data="data[indextr].teacher">
                            {{ data[indextr].teacher }}
                        </vs-td>

                        <vs-td v-if="user && user.role.is_org_admin && data[indextr].advisor" :data="data[indextr].advisor">
                            {{ data[indextr].advisor }}
                        </vs-td>

                        <vs-td :data="data[indextr].student_count" style="cursor:pointer;" >
                            <a  @click="selectItem(data[indextr])">{{ data[indextr].student_count }}</a>
<!--                            <a @click="func()">{{ data[indextr].student_count }}</a>-->
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <vs-popup classContent="popup-example" title="Список студентов" :active.sync="popupActive2">
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="listScroll"
                :key="$vs.rtl">
                <ul>
                    <li
                        class="todo_todo-item"
                        v-for="(list, index) in select"
                        :key="'list_student_'+index"
                        :style="[{transitionDelay: (index * 0.1) + 's'}]">

                        <div class="emc_card px-4 py-4 list-item-component">
                            <div class="vx-row">
                                <div
                                    class="vx-col w-full flex sm:items-center sm:flex-row flex-col"
                                >
                                    <div class="lg:flex w-full lg:justify-between lg:items-center">
                                        <div
                                            style="width: 70%"
                                            class="user_detail flex items-center justify-between"
                                        >
                                            <div class="user_name flex items-center">
                                                {{ index+1 }}.
                                                {{fullName(list)}}
                                            </div>
                                            <div class="mobile_div"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </component>

            <vs-popup title="Inner popup" :active.sync="popupActive3">
                <p>Список студентов</p>
            </vs-popup>
        </vs-popup>
        <vs-popup
            class="results-popup"
            :title="$t('students-list')"
            :active.sync="modalStudents"
        >
            <div class="px-4 mt-2">
                <div class="mt-2" v-for="item in listStudents" :key="item.uid">
                    <div class="flex items-center justify-between">
                        <vs-avatar :src="item.avatar" size="50px" />
                        <h4 class="ml-4">

                            {{ item.lastName }} {{ item.firstName }}
                            {{ item.middleName }}
                        </h4>
                        <vs-button
                            class="ml-4"
                            @click="viewProfile(item.profileId)"
                            >{{ $t("view_profile") }}</vs-button
                        >
                    </div>
                    <vs-divider></vs-divider>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import userSetting from '@/localNodeModules/setting/user.js'

export default {
    props: {
        active: Boolean,
        filters: Boolean,
    },
    mixins:[userSetting],
    data() {
        return {
            listResults: [],
            page: 0,
            loading: false,
            infiniteStatus: true,
            status: true,
            interval: false,

            intervalParams: {
                token: null,
                uid: null,
            },
            listStudents: [],
            modalStudents: false,
            value1: '',
            value2: '',
            popupActive2: false,
            popupActive3: false,
            daa:[],
            select:null
        };
    },
    computed: {
        user() {
            return this.$store.state.user.user
        }
    },
    watch: {
        active() {
            if (this.active) {
                this.loadMore();
            }
        },
        filters() {
            if (this.filters) {
                this.status = true;
                this.page = 0;
                this.listResults = [];
                this.loadMore();
            }
        },
    },
    created() {
        this.loadMore();
    },
    components: {
        VuePerfectScrollbar,
    },
    methods: {
        selectItem(item) {
            this.select =item.students;

            this.popupActive2 = true;
        },
        async openStudents(data) {
            this.$vs.loading();
            this.listStudents = (
                await this.$http("advisors/registration/results/students/", {
                    params: {
                        discipline_id: data.discipline_id,
                        teacher_id: data.teacher_id,
                        load_type_id: data.load_type_id,
                        hours: data.hours,
                        language_id: data.language_id,
                        advisor_id: data.advisor_id,
                        acad_period_uid: data.acad_period_uid,
                    },
                })
            ).data;
            this.daa = this.listStudents
            this.modalStudents = true;
            this.$http("advisors/registration/results/students/", {
                params: {
                    discipline_id: data.discipline_id,
                    teacher_id: data.teacher_id,
                    load_type_id: data.load_type_id,
                    hours: data.hours,
                    language_id: data.language_id,
                    advisor_id: data.advisor_id,
                    acad_period_uid: data.acad_period_uid,
                },
            })
            this.$vs.loading.close();
        },
        viewProfile(uid) {
            this.$router.push({
                name: "students-list-view",
                query: { uid: uid },
            });
        },
        // Загрузка данных
        async loadMore() {
            if (this.active && this.status) {
                this.loading = true;

                this.$vs.loading();

                setTimeout(async () => {
                    this.page += 1;
                    let query = this.$route.query;
                    delete query["version-table"];
                    const res = (
                        await this.$http.get("advisors/registration/results", {
                            params: { page: this.page, ...query },
                        })
                    ).data;

                    // this.listResults.push(...res.results);

                    res.results.forEach((el) => {
                        this.listResults.push(el);
                    });

                    if (res.next === null) {
                        this.status = false;
                    }

                    this.loading = false;
                    this.$vs.loading.close();
                }, 1000);
            }
        },
        async getExcelToken() {
            try {
                this.$vs.loading({
                    container: "#button-load-more-posts",
                    scale: 0.45,
                });
                let query = this.$route.query;
                delete query["version-table"];

                const res = await this.$http("reports/excel/reg_result/", {
                    params: query,
                });
                if (res.status === 200) {
                    this.intervalParams = res.data;
                    this.intervalParams.get = "status";

                    this.$vs.notify({
                        title: this.$t("file_process"),
                        time: 10000,
                        text: this.$t("some_time"),
                        color: "primary",
                        icon: "error",
                    });
                    this.interval = setInterval(async () => {
                        await this.getStatus();
                    }, 10000);
                }
            } catch (e) {}
        },
        async getStatus() {
            const res = await this.$http("/reports/get_file/", {
                params: this.intervalParams,
            });
            if (res.data.done) {
                clearInterval(this.interval);
                this.downloadFile();
            }
        },
        async downloadFile() {
            await this.$http
                .get("reports/get_file/", {
                    responseType: "blob",
                    params: { token: this.intervalParams.token, get: "file" },
                })
                .then((response) => {
                    // Создаю тег а виртуальный
                    const link = document.createElement("a");
                    // Добавляю к нему ссылку на закачку
                    link.href = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    // Устанавливаю к нему атрибуты названия файла и метод
                    link.setAttribute(
                        "download",
                        this.$t("registration-results") + ".xls"
                    );
                    // Вставляю/заменяю тег а в конце body
                    document.body.appendChild(link);
                    // Произвожу клик
                    link.click();
                });

            this.$vs.loading.close("#button-load-more-posts > .con-vs-loading");
        },
    },

    beforeDestroy() {
        clearInterval(this.interval);
    },
};
</script>
<style lang="scss" >
.con-vs-popup .vs-popup {
    width: 800px !important;
}
</style>
<style>
#registration-results .vs-table--tbody-table {
    min-width: 0px !important;
}
</style>
